export { FooterWithData } from './FooterWithData/FooterWithData';
export { prefetchFooterData } from './hooks/useFooterData';
